import { AdCampaignWizard } from '@/components/mediaBuying/adCampaign/AdCampaignWizard'

const CreateCampaign = () => {
    return <AdCampaignWizard />
}

export default CreateCampaign